import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root', // Hace que este servicio esté disponible en toda la aplicación
})
export class TagUpdateService {
  // Observable para emitir notificaciones de actualizaciones
  private readonly tagsUpdatedSource = new Subject<void>();

  // Observable al que otros componentes se pueden suscribir
  tagsUpdated$ = this.tagsUpdatedSource.asObservable();

  // Método para emitir una notificación
  notifyTagsUpdated() {
    this.tagsUpdatedSource.next();
  }
}
